import { Component, OnInit } from '@angular/core';
import { RolesService } from '@services/auth/role.service';
import { StoreAppService } from '@services/cleanfill-core/store-app/store-app.service';
import { PortalState } from '@view-models/enums/portal-state';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'site-portal',
  templateUrl: './site-portal.component.html',
  styleUrls: ['./site-portal.component.scss']
})
export class SitePortalComponent implements OnInit {
  subscriptions = new Subscription();
  portal$: Observable<PortalState>;
  PortalState = PortalState;
  portalState: PortalState;

  constructor(private appStore: StoreAppService, public roleService: RolesService) {}

  ngOnInit(): void {
    this.portal$ = this.appStore.portalState$;
    this.subscriptions.add(this.appStore.portalState$.subscribe(portal => (this.portalState = portal)));
  }

  setSourceSites(): void {
    this.appStore.setPortalState(PortalState.SOURCE_SITE);
  }

  setFillSites(): void {
    this.appStore.setPortalState(PortalState.FILL_SITE);
  }
}
